import 'angular-local-storage';
import 'angular-mocks';

import createStub from '../olr-common/createStub';
import ClassRoomService, {ClassRoomServiceStub} from './ClassRoomService';
import SubjectService, {SubjectServiceStub} from './SubjectService';
import TodoListService, {TodoListServiceStub} from './TodoListService';
import IdentityMgmtService from './IdentityMgmtService';
import StudentService from './StudentService';
import ExamService from './ExamService';
import AttendanceService from './AttendanceService';
import AnnouncementService from './AnnouncementService';
import HomeworkService from './HomeworkService';
import AdminService from './AdminService';
import ReportService from './ReportService';

let namespace = angular.module('olr-mainfe-api', [
"LocalStorageModule"
]);

createStub(namespace, ClassRoomServiceStub);
createStub(namespace, SubjectServiceStub);

namespace.service('ClassRoomService', ClassRoomService);
namespace.service('TodoListService', TodoListService);
namespace.service('SubjectService', SubjectService);
namespace.service('IdentityMgmtService', IdentityMgmtService);
namespace.service('StudentService', StudentService);
namespace.service('ExamService', ExamService);
namespace.service('AttendanceService', AttendanceService);
namespace.service('AnnouncementService', AnnouncementService);
namespace.service('HomeworkService', HomeworkService);
namespace.service('AdminService', AdminService);
namespace.service('ReportService', ReportService);

export default namespace.name;




/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-api/index.js
 **/